
import {API_URL, DEFAULT_PER_PAGE} from "../../env"
import VueCookies from 'vue-cookies'
import router from "../../router/index"
import {ResponseWrapper, ErrorWrapper, _setAuthData, _resetAuthData, _handleError} from "../../services/utils"
import Vue from "vue";
import $router from "../../router";

export default {
	namespaced: true,
	state: {
		loading: false,
		accessToken: null,
		refreshToken: null,
		user: {
			id: null
		},
		genders: [{text: "دختر", value: "FEMALE"}, {text: "پسر", value: "MALE"}],
		itemTypes: [{text: "داستان", value: "STORY"}],
		OS: [{text: 'ANDROID', value: 'ANDROID'}, {text: 'IOS', value: 'IOS'}],
		usersRoles: [
			{text: "ادمین", value: "admin"},
			{text: "نویسنده", value: "author"},
			{text: "قصه گو", value: "narrator"},
			{text: "تصویرگر", value: "illustrator"},
			{text: "کارکتر", value: "CHARACTER"},
			{text: "کاربر عادی", value: "normal_user"}],
		parsedToken: {},
		per_page: [
			{text: 10, value: 10},
			{text: 20, value: 20},
			{text: 50, value: 50},
			{text: 100, value: 100},
			{text: 1000, value: 1000}
		]
	},

	mutations: {
		SET(state, {key, value}) {
			state[key] = value
		},

		DELETE(state, {key, type = 'string'}) {
			switch (type) {
				case 'array':
					state[key] = []
					break
				case 'object':
					state[key] = {}
					break
				case 'boolean':
					state[key] = false
					break
				default:
					state[key] = null
			}
		},

		APPEND(state, {key, value}) {
			// console.log(state)
			if (typeof state[key] !== 'object')
				return false

			if (Array.isArray(state[key])) {
				// console.log('also here')
				state[key].push(value)
			}

			if (state[key] && !Array.isArray(state[key]) && state[key] !== null) {
				// console.log(value)
				state[key] = {...state[key], ...value}
				// console.log(state)
			}
		}
	},

	getters: {},

	actions: {

		async crud({commit, state, dispatch}, {action, section, id, query, data, auth = true, showError = false, perPage, requestOptions}) {
			const http = await this._vm.$http.init(auth)
			const time = new Date();
			const currentTime = time.getTime();
			let perPg = ''
			if (action === 'get')
				perPg = perPage || DEFAULT_PER_PAGE

			const url = `${API_URL}/${section}${(id && id !== 'new') ? `/${id}` : ''}?ct=${currentTime}&admin=true${action === 'get' && perPg ? `&per_page=${perPg}` : ''}${query ? `&${query}` : ''}`
			let result

			try {
				switch (action) {
					case 'delete':
						result = await http.delete(url, requestOptions)
						break;
					case 'put':
					case 'post':
						result = await http[action](url, data || {}, requestOptions)
						break;
					case 'get':
					default:
						result = await http.get(url, requestOptions)
				}
				if (result) {
					return new ResponseWrapper(result, result.data)
				}
			} catch (e) {
				console.log(e)
				if (e.response) {
					const error = new ErrorWrapper(e)
					await _handleError(error, action, showError)
					throw error
				}
				throw e
			}
		},

		async alerts({commit, state, dispatch}, {type, title, message}) {

			switch (type) {
				case 'confirm':
					await this._vm.$confirmAlert(title);
					break;
				case 'success':
					await this._vm.$successAlert(title);
					break;
				case 'error':
					await this._vm.$errorAlert(title, message);
					break;
			}
			return null
		},

		async logout({commit, dispatch}) {
			commit('SET', {key: 'loading', value: true})
			await _resetAuthData(false)
			await $router.push({name: 'auth'})
			commit('SET', {key: 'loading', value: false})
			return dispatch('alerts', {type: 'success', title: 'با موفقیت خارج شدید.'})
		}
	}
}
